import React from "react";
import { MdPlace, MdEmail, MdPhone } from "react-icons/md";

import texts from "../../texts.json";
import verticalLogo from "../../images/vertical-logo.png";

import "./style.css";

const FooterComponent = (props) => {
  const index = props.index;

  return (
    <div className="section footer-section">
      <div className="section-content footer-content">
        <div className="logo-footer">
          <img className="img-footer" src={verticalLogo} alt="GF ESTRAZIONI" />
        </div>

        <div className="info-container">
          <div className="info-contacts">
            <div className="info-emails">
              <div className="info-title">
                <MdEmail size="1.5em" style={{ color: "#ffffff" }} />
                <div>
                  <h3>&nbsp;{texts.footer.emails[index]}</h3>
                </div>
              </div>

              <p>gf.estrazioni@libero.it</p>
              <p>gfestrazionisrl@pec.it</p>
            </div>

            <div className="info-phones">
              <div className="info-title">
                <MdPhone size="1.5em" style={{ color: "#ffffff" }} />
                <div>
                  <h3>&nbsp;{texts.footer.telefones[index]}</h3>
                </div>
              </div>
              <p>+59 3282386431</p>
              <p>+59 030 6898008 (Fax)</p>
            </div>
          </div>
          <div className="info-address">
            <div className="info-title address">
              <MdPlace size="1.8em" style={{ color: "#ffffff" }} />
              <div>
                <p>&nbsp;Via Camprelle, 84 - 25080</p>
                <p>&nbsp;Nuvolera (Brescia) Italy</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="made-by">
        <a
          href="https://www.linkedin.com/in/lucas-vinicius-ribeiro-1b9574164/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {texts.footer.madeBy[index]}
        </a>
      </div>
    </div>
  );
};

export default FooterComponent;
